import fetch from 'isomorphic-fetch'
import Session from '@mainServices/User/session'
import { KEY_LOCAL_STORAGE_TOKEN } from '../../../auth/Auth.constants'

const API_URL_AVT = import.meta.env.VITE_AVT_API_URL

const createRequestBody = (requestObj) => {
  return {
    method: requestObj.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestObj.body)
  }
}

const getClients = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/clients`
  const requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const profile = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/profile`
  let requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const userList = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/users`
  let requestBody = await createRequestBody({
    method: 'GET'
  })
  const users = await fetch(requestUrl, requestBody)
  return users
}

const create = async (firstName, lastName, email, password, roleId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/users`
  const requestBody = await createRequestBody({
    method: 'POST',
    body: {
      firstName,
      lastName,
      email,
      password,
      roleId
    }
  })
  return fetch(requestUrl, requestBody)
}

const getImage = async (url) => {
  let requestUrl = `${API_URL_AVT}/odin/api/getS3File?`

  if (url) {
    requestUrl += `url=${encodeURI(url)}`
  }

  // Force add authorization headers because urls with 's3.amazonaws.com' is excluded in fetch interceptor.
  const requestBody = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${Session.get(KEY_LOCAL_STORAGE_TOKEN)}`
    }
  }

  return fetch(requestUrl, requestBody)
    .then((response) => {
      return response.blob()
    })
    .then((blob) => {
      return blob
    })
    .catch((err) => {
      throw err
    })
}

export { profile, userList, create, getImage, getClients }
